@if (exibir) {
  <div class="simple-modal" role="dialog" aria-modal="true" aria-labelledby="boleto-modal-titulo">
    <div class="simple-modal-dialog modal-lg">
      <div class="simple-modal-content">
        <div class="simple-modal-header">
          <h5 class="simple-modal-title" id="boleto-modal-titulo">
            {{ boletoPreview?.title }}
          </h5>
          <button type="button" class="btn-close" aria-label="Fechar" (click)="toggle()"></button>
        </div>
        <div class="simple-modal-body">
          <embed [src]="trustedUrl" type="application/pdf" width="100%" title="Boleto de pagamento" aria-label="Visualização do Boleto" />
        </div>
      </div>
    </div>
  </div>
  <div (click)="toggle()" class="overlay" aria-hidden="true"></div>
}
